import React, {useCallback, useEffect, useState} from 'react';
import { useAuth } from "../../services/use-auth.js";
import { useSpring, animated } from 'react-spring'
import {Link, NavLink, useHistory, useLocation} from "react-router-dom";
import './header.scss';
import logo from '../../assets/images/logo_en.svg';
import courses from '../../assets/images/menu/courses.svg';
import event from '../../assets/images/menu/event.svg';
import materials from '../../assets/images/menu/materials.svg';
import surveys from '../../assets/images/menu/question-cog.svg';
import organization from '../../assets/images/menu/organization.svg';
import logout from '../../assets/images/menu/exit.svg';
import {useTranslation} from "react-i18next";

export default function Header() {
    const auth = useAuth();
    const location = useLocation();
    const { t } = useTranslation();
    const [showSideMenu, setShowSideMenu] = useState(false);
    const [style, animate] = useSpring(() => ({}));
    const history = useHistory();
    const closeSideMenu = useCallback(() => {
        animate({
            to: {
                right: -300,
            }
        });
        setShowSideMenu(false);
    }, [animate])

    useEffect(() => {
        history.listen((location) => {
            closeSideMenu();
        })
    }, [closeSideMenu, history])

    return (
        <header id="header" className="header block">
            { showSideMenu && <div className="pageslideBg" style={{display: 'block'}} onClick={closeSideMenu} />}
            <div className="main-container">
                <div className="flex-center">
                    <div className="top-bar-left">
                        <a href="/">
                            <img src={logo} alt="" />
                        </a>
                    </div>
                    <div className="top-bar-right">
                        <a onClick={() => {
                            animate({
                                from: {
                                    right: -300,
                                },
                                to: {
                                    right: 0,
                                    display: 'block',
                                }
                            });
                            setShowSideMenu(true)
                        }} id="openPageslide">
                        <span className="nav-toggle-button ssm-toggle-nav">
                            <div className="menu-bar menu-bar-top"/>
                            <div className="menu-bar menu-bar-middle"/>
                            <div className="menu-bar menu-bar-bottom"/>
                        </span>
                        </a>
                        <nav id="nav" className="header-nav">
                            <animated.ul style={style} className="main-menu" id="mainmenu">
                                <li>
                                    <img src={courses} alt="" />
                                    <a href="/testings">{t('menu.testings')}</a>
                                </li>
                                <li>
                                    <img src={courses} alt="" />
                                    <a href="/courses">{t('menu.courses')}</a>
                                </li>
                                <li>
                                    <img src={event} alt="" />
                                    <NavLink activeClassName="current-page" to="/conferences">{t('menu.conferences')}</NavLink>
                                </li>
                                <li>
                                    <img src={materials} alt="" />
                                    <a href="/library">{t('menu.library')}</a>
                                </li>
                                <li>
                                    <img src={surveys} alt="" />
                                    <NavLink activeClassName="current-page" to="/surveys">{t('menu.surveys')}</NavLink>
                                </li>
                                <li>
                                    <img src={organization} alt="" />
                                    <NavLink activeClassName="current-page" to="/organizations">{t('menu.organizations')}</NavLink>
                                </li>
                                {
                                    !auth.user ?
                                    <>
                                        <li>
                                            <img src={logout} />
                                            <Link className="btn-login" to={{pathname: "/account/login", state: {from: location}}} >{t('buttons.login')}</Link>
                                        </li>
                                        <li>
                                            <a href="/account/registration" className="btn-registration">
                                                {t('buttons.registration')}
                                            </a>
                                        </li>
                                    </> :
                                        <li className="has-sub">
                                            <a href="/profile">
                                                <div className="user-photo">
                                                    <img src={auth.user.avatarUrl ?? '/img/no-photo.svg' } alt="" className="img-fill" />
                                                </div>
                                                {  (auth.user.firstName || auth.user.lastName) ? auth.user.firstName + ' ' + auth.user.lastName : t('menu.defaultUsername')}
                                            </a>
                                            <ul className="profile-menu">
                                                <li>
                                                    <img src="/img/menu/user.svg" alt="" />
                                                        <a href="/profile">{t('menu.summary')}</a>
                                                </li>
                                                <li>
                                                    <img src="/img/menu/user.svg" alt="" />
                                                    <NavLink to="/portfolio">{t('menu.portfolio')}</NavLink>
                                                </li>
                                                <li>
                                                    <img src="/img/menu/promocode.svg" alt="" />
                                                        <a href="/promoCodes">{t('menu.promocodes')}</a>
                                                </li>
                                                <li>
                                                    <img src="/img/menu/exit.svg" alt="" />
                                                        <a onClick={() => auth.signOut()}>{t('buttons.logout')}</a>
                                                </li>
                                            </ul>
                                        </li>
                                }

                            </animated.ul>
                        </nav>
                    </div>
                </div>
            </div>
        </header>
    )
}
